import { render, staticRenderFns } from "./writeInfo.vue?vue&type=template&id=f8060072&scoped=true"
import script from "./writeInfo.vue?vue&type=script&lang=js"
export * from "./writeInfo.vue?vue&type=script&lang=js"
import style0 from "./writeInfo.vue?vue&type=style&index=0&id=f8060072&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8060072",
  null
  
)

export default component.exports